import type { OfferType } from '@makemydeal/dr-platform-types';
import type { PencilInputsByOfferType, PartialPenciledInputsWithAllTypes, PenciledInputsState } from '../../../types/commonTypes';
import * as types from '../../../types/actionTypes';

export const handleTaxAndFeeCases = (
    state: PenciledInputsState,
    action: any,
    offerType: OfferType
): PartialPenciledInputsWithAllTypes => {
    switch (action.type) {
        case types.UPDATE_PAYMENT_FEES_OVERRIDE: {
            if (!state.byOfferType) return state;
            const newState = {
                ...state,
                byOfferType: {
                    ...state.byOfferType,
                    [offerType]: {
                        ...state.byOfferType?.[offerType],
                        feesOverride: action.payload
                    }
                }
            };
            return newState;
        }

        case types.UPDATED_TOTAL_TAX_OVERRIDE: {
            const { manualTotalTax, manualTotalTaxEdited } = action.payload || {};
            if (!state.byOfferType) return state;
            const newState = {
                ...state,
                byOfferType: {
                    ...state.byOfferType,
                    [offerType]: {
                        ...state.byOfferType?.[offerType],
                        manualTotalTax,
                        manualTotalTaxEdited,
                        taxItems: []
                    }
                } as PencilInputsByOfferType
            };
            return newState;
        }

        case types.RESET_TAX_OVERRIDES: {
            if (!state.byOfferType) return state;
            return {
                ...state,
                byOfferType: {
                    ...state.byOfferType,
                    [offerType]: {
                        ...state.byOfferType?.[offerType],
                        manualTotalTax: undefined,
                        manualTotalTaxEdited: undefined
                    }
                }
            };
        }

        case types.UPDATED_TOTAL_TAX_UPFRONT_OVERRIDE: {
            if (!state.byOfferType) return state;
            const newState = {
                ...state,
                byOfferType: {
                    ...state.byOfferType,
                    [offerType]: {
                        ...state.byOfferType?.[offerType],
                        taxOverrideUpfront: action.payload
                    }
                }
            };
            return newState;
        }

        default: {
            return state;
        }
    }
};
